import { FormEvent, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { faSearch } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Image, Input } from '@/ui'
import { HumansOfHeard } from './HumansOfHeard'
import { isUserIdSearch } from './paginated-users-table/controls'

const MIN_SEARCH_STRING_LENGTH = 2

const HEADER_IMAGE_SRC =
  'https://heard-images.s3.amazonaws.com/assets/oneteam-oneheard-halloween.png'

const SEARCH_PLACEHOLDER = 'Search by name, email or user ID'

export const AdminFinancesPanel = () => {
  const navigate = useNavigate()
  const inputRef = useRef<HTMLInputElement>(null)
  const [searchString, setSearchString] = useState('')

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const trimmed = searchString.trim()
  const isValid =
    isUserIdSearch(trimmed) || trimmed.length >= MIN_SEARCH_STRING_LENGTH

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    if (!isValid) {
      return
    }
    navigate(`/admin/finances/list-users?q=${encodeURIComponent(trimmed)}`)
  }

  return (
    // Margins, min-height and corner radius cancel mainContentStyles (routes/layoutStyles.ts); update together.
    <div className="-mb-6 flex min-h-[calc(100vh-1.5rem)] w-full flex-col sm:-mb-8 sm:min-h-[calc(100vh-2rem)] md:-mb-10 md:min-h-[calc(100vh-2.5rem)]">
      <div className="-mx-4 -mt-6 flex flex-col items-center rounded-tl-[40px] bg-moss-0 px-4 pb-12 pt-8 sm:-mx-6 sm:-mt-8 md:-mx-14 md:-mt-10">
        <Image
          src={HEADER_IMAGE_SRC}
          alt="One team, one Heard"
          loading="eager"
          objectFit="contain"
          className="h-auto w-full max-w-xl"
        />
      </div>
      <form
        onSubmit={handleSubmit}
        className="relative -mt-7 w-full max-w-4xl self-center px-4"
      >
        <div className="relative w-full">
          <Icon
            icon={faSearch}
            size="sm"
            color="text-neutral-500"
            backgroundClassName="pointer-events-none absolute left-4 top-1/2 z-10 -translate-y-1/2"
          />
          <Input
            ref={inputRef}
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
            placeholder={SEARCH_PLACEHOLDER}
            inputClassName="h-14 bg-neutral-0 pl-12 text-lg shadow-md"
            aria-label="Search users"
          />
        </div>
      </form>
      <div className="mt-auto hidden pt-10 [@media(min-height:700px)_and_(min-width:1024px)]:block">
        <HumansOfHeard />
      </div>
    </div>
  )
}
